const gameConfig = {
  keys: {
    keysFirstPlayer: ["a", "s", "d"],
    keysSecondPlayer: ["j", "k", "l"],
  },
  playerOneName: "first",
  playerTwoName: "second",
  timerCountBeforeGameStart: 3,
  answersCount: 5,
  showFirstScreenTime: 3000,
  showCorrectAnswerDelay: 2000,
  showCorrectAnswerTime: 7000,
  showWrongAnswerDelay: 3000,
  showWrongAnswerTime: 3000,
  showWinnerScreenTime: 10000,
  timeForAnswer: 14000,
};

export default gameConfig;
